import React from 'react';
import iconNs from '@ant-design/icons';

const Icon = iconNs.default || iconNs;

export function MusicXmlViewerIconComponent() {
  return (
    <svg height="1em" style={{ enableBackground: 'new 0 0 1000 1000' }} width="1em" viewBox="0 0 1000 1000">
      <path style={{ fill: 'currentColor' }} d="M412.53 292.07c-18.54-5.65-38.28 4.74-43.98 23.35L264.42 655.21c-5.69 18.59 4.76 38.28 23.35 43.98 3.44 1.05 6.9 1.55 10.33 1.55 15.06 0 29.01-9.75 33.65-24.91l104.13-339.79c5.7-18.58-4.76-38.26-23.35-43.97zm-211.79 70.37c-13.75-13.75-36.03-13.75-49.79 0L26.74 486.66a35.193 35.193 0 0 0 .38 50.15l124.22 120.57c6.84 6.64 15.68 9.94 24.52 9.94 9.19 0 18.36-3.58 25.26-10.69 13.55-13.95 13.22-36.24-.74-49.79l-98.57-95.68 98.94-98.95c13.75-13.74 13.75-36.02-.01-49.77zm772.52 124.22L849.04 362.44c-13.75-13.75-36.03-13.75-49.79 0-13.75 13.75-13.75 36.03 0 49.79l98.94 98.95-98.57 95.68c-13.96 13.55-14.29 35.84-.74 49.79 6.9 7.11 16.08 10.69 25.26 10.69 8.84 0 17.69-3.3 24.52-9.94l124.22-120.57a35.193 35.193 0 0 0 10.69-25c.07-9.44-3.64-18.5-10.31-25.17zM673.28 254.6c-15.55 0-28.17 12.61-28.17 28.17v257.11c-33.54-10.93-77.79-8.56-121.19 9.61C449.5 580.63 406 646.1 426.76 695.71c20.76 49.61 97.92 64.58 172.34 33.44 62.82-26.29 103.43-77.02 102.13-122.04.05-.68.21-1.33.21-2.02V282.77c0-15.55-12.61-28.17-28.16-28.17z" />
    </svg>
  );
}

function MusicXmlViewerIcon() {
  return (
    <Icon component={MusicXmlViewerIconComponent} />
  );
}

export default MusicXmlViewerIcon;
